function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M384 1143q27 0 50 11t41 29 27 42 10 51v306q0 27-9 51t-27 42-41 29-51 11q-27 0-50-10t-41-29-27-43-10-51v-306q0-27 9-51t27-42 41-29 51-11zm384-479q27 0 50 10t41 29 27 43 10 51v785q0 27-9 51t-27 42-41 29-51 11q-27 0-50-10t-41-29-27-43-10-51V797q0-27 9-51t27-42 41-29 51-11zm768-331q27 0 50 11t41 29 27 42 10 51v1112q0 27-9 51t-27 42-41 29-51 11q-27 0-50-10t-41-29-27-42-10-51V466q0-27 9-51t27-42 41-29 51-11zm-384 532q27 0 50 11t41 29 27 42 10 51v584q0 27-9 51t-27 42-41 29-51 11q-27 0-50-10t-41-29-27-43-10-51V998q0-27 10-51t27-42 40-29 51-11z"
});

function SvgPowerbi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2048 2048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerbi);
export default __webpack_public_path__ + "static/media/powerbi.a0346fa8.svg";
export { ForwardRef as ReactComponent };